import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
    KeyboardAvoidingView,
    Platform,
    Pressable,
    SectionList,
    StyleSheet,
    Text,
    View,
} from 'react-native';
import { MainNavProps } from "../navigation/main/MainParamList";
import { useStore } from "../../store/UserStore";
import { CListItem, isSystemAcc } from "./CListItem";
import {
    color_1E1E1E,
    color_333333,
    color_999999, color_BEBEBE,
    color_F1F1F1,
    color_main,
    ColorF5F5F5,
    ColorGrey,
    white
} from "../../assets/style/colors";
import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import * as ImSdk from "../../../imsdk/api";
import {
    Str_Contact, Str_CreatTopicErr,
    Str_GroupChat,
    Str_GroupName,
    Str_InProhibition,
    Str_MassSendingAssistant,
    Str_No_documents,
    Str_No_images,
    Str_No_videos,
    Str_SelectAll,
    Str_SendComplete,
    Str_SendFail,
    Str_SendMsgPlaceholder,
    Str_SpeakFrequently,
    Str_UnSelectAll,
} from "../../language/string_res";
import { User } from "../../../imsdk/db/t_user";
import { useIsFocused } from "@react-navigation/native";
import { getUserName } from "./chat-helper";
import { GroupSummary } from "../../../imsdk/db/t_group_summary";
import { MultipleSendMsgRequestData } from "../../net/request";
import { CryptEngine } from "../../utils/CryptEngine";
import { UserSchema } from "../../realm/contactSchema";
import { ChartMessageItem, ChatType, MessageType, strToType } from "../../constants/types";
import time from "../../../imsdk/time";
import { multipleSendMsgs, sendMsg } from "../../net/service";
import { isGroupTopic } from "../../utils/utils";
import { getLastSendMsg, setLastSendMsg } from "../../net/database";
import { showToast } from "../../components/Toast";
import { getEncrypt } from "../../store/token";
import { buildSingleTopicId } from "../../utils/helper";
import log from "../../../imsdk/log";
import { ActiveIcon, ChatInput, ChatPropsEvent } from "./ChatInput";
import { upsetMsg } from '../../store/ChatStore';
import { PickerResult } from '../../utils/PicOrCameraManager';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
// import { MediaManager } from '../../utils/MediaManager';
import { uploadProgressFile } from '../../utils/uploadImage';
import { hideLoading, showLoading } from '../../components/Loading';
import { UploadKey } from '../../utils/ReactBlobUtil';

interface MassSendingData {
    title: string,
    type: 'single' | 'group',
    data: any[]
}

export const MassSendingAssistant = ({ }: MainNavProps<'MassSendingAssistant'>) => {
    // 转发会话中的选中项
    const [section, setSection] = useState<MassSendingData[]>([]);
    const im = ImSdk.getInstance();
    const currentUid = im.CurrentUid(); // 当前用户

    const { state } = useStore();
    const isFocused = useIsFocused();


    const [selectUids, setSelectUids] = useState<Set<number>>(
        new Set<number>()
    );
    const [selectTids, setSelectTids] = useState<Set<string>>(
        new Set<string>()
    );

    // 任务总数
    const tagCount = useRef<number>(0)
    // 任务完成总数
    const hadDoneTags = useRef<Set<string>>(new Set<string>())
    // 添加一个状态来触发重新渲染
    const [doneCount, setDoneCount] = useState(0);

    const [isSelectAll, setSelectAll] = useState(false)
    const refUsers = useRef<User[]>([])
    const refGroups = useRef<GroupSummary[]>([])
    const [isBottomSafeAreaShow, setBottomSafeAreaShow] = useState(false);
    const insets = useSafeAreaInsets();

    useEffect(() => {
        setSelectUids(new Set());
        setSelectTids(new Set());
        refUsers.current = []
        refGroups.current = []
    }, []);

    useEffect(() => {
        if (tagCount.current > 0 && tagCount.current === doneCount) {
            hideLoading()
            showToast(Str_SendComplete);
        }
    }, [doneCount]); // 依赖 doneCount 的变化

    useEffect(() => {
        setSelectAll(selectUids.size === refUsers.current.length && selectTids.size === refGroups.current.length)
        const isHadSelected = (selectUids.size > 0 || selectTids.size > 0)
        setBottomSafeAreaShow(isHadSelected)
    }, [selectUids, selectTids]);

    const addDoneTag = (tag: string) => {
        hadDoneTags.current.add(tag);
        // 更新状态触发重新渲染
        setDoneCount(hadDoneTags.current.size);
    };

    const [contacts, contactBlacks] = useMemo(() => {
        return [state?.contactList, state?.contactBlackList]
    }, [state?.contactList, state?.contactBlackList]);

    useEffect(() => {
        const users = contactsFilterDeleted()
        refUsers.current = users
        setSection(prevState => {
            const list = prevState.filter(value => value.type === 'single')
            if (list.length > 0) {
                list[0].data = users
                return prevState
            } else {
                return [{ title: Str_Contact, type: 'single', data: users }, ...prevState]
            }
        })

    }, [contacts, contactBlacks]);


    useEffect((() => {
        if (isFocused) {
            im.GetGroupSummaryList(true).then((res) => {
                if (res && res.groupSummarys && res.groupSummarys.length > 0) {
                    const group = res.groupSummarys
                    refGroups.current = group
                    setSection(prevState => {
                        const list = prevState.filter(value => value.type === 'group')
                        if (list.length > 0) {
                            list[0].data = group
                            return prevState
                        } else {
                            return [...prevState, { title: Str_GroupChat, type: 'group', data: group }]
                        }
                    })
                }
            })
        }
    }), [isFocused]);

    function onClick(type: 'single' | 'group', item: any) {
        if (type === 'single') {
            const user = item as User
            const uids = new Set(selectUids)
            if (uids.has(user.uid)) {
                uids.delete(item.uid);
            } else {
                uids.add(item.uid);
            }
            setSelectUids(uids);
        } else {
            const group = item as GroupSummary
            const tids = new Set(selectTids)
            if (tids.has(group.tid)) {
                tids.delete(group.tid);
            } else {
                tids.add(group.tid);
            }
            setSelectTids(tids)
        }
    }

    const RenderItem = ({ section, item }: { section: MassSendingData, item: any }) => {
        let name: string;
        let avatar: string;
        let isChecked: boolean;
        let uid = 0
        if (section.type === "single") {
            const user = item as User;
            name = getUserName(user);
            avatar = user?.avatar ?? "";
            isChecked = selectUids.has(user.uid);
            uid = item.uid;
        } else {
            const group = item as GroupSummary;
            name = group?.remark || group?.name || Str_GroupChat;
            avatar = group?.avatar ?? "";
            isChecked = selectTids.has(group.tid);
        }
        return (
            <Pressable
                onPress={() => onClick(section.type, item)}
                style={({ pressed }) => [
                    Platform.OS === 'web' && {
                        cursor: 'pointer',
                        opacity: pressed ? 0.7 : 1,
                    }
                ]}>
                <CListItem
                    hasRadio={true}
                    id={item.uid}
                    left={{ name, avatar, uid: uid }}
                    isChecked={isChecked}
                    center={<Text style={{ fontSize: 16, color: color_333333 }}>{name}</Text>}
                    onClick={() => onClick(section.type, item)}
                />
            </Pressable>
        )
    }
    const SectionHeader = ({ section: { title } }: { section: MassSendingData }) => (
        <Text style={styles.header}>{title}</Text>
    );

    function contactsFilterDeleted() {
        const c = contacts ?? []
        const b = contactBlacks ?? []
        const result = new Set<User>()
        c.forEach((value) => {
            const b1 = value.status !== 'deleted'
            const b2 = b.some(item => item.uid === value.uid);
            const b3 = !isSystemAcc(value.uid)

            if (b1 && !b2 && b3) {
                result.add(value)
            }
        })
        return Array.from(result)
    }

    const selectAll = () => {
        if (isSelectAll) {
            setSelectAll(false);
            setSelectUids(new Set());
            setSelectTids(new Set());
        } else {
            setSelectAll(true);
            const uids = refUsers.current.map(value => value.uid)
            const tids = refGroups.current.map(value => value.tid)
            setSelectUids(new Set(uids));
            setSelectTids(new Set(tids));
        }
    }


    const handleSubmitMsg = async (res: ChatPropsEvent) => {
        const { content, type, meta } = res

        // 发送前重置统计
        hadDoneTags.current = new Set();
        setDoneCount(0);

        let cid = Date.now()
        const msg: ChartMessageItem = {
            tid: "",
            mid: "",
            cid: cid,
            type: type,
            content: content,
            encrypt: 0, // 当前未加密,因为要存数据库
            meta: (meta ?? {}) as any,
            sender: currentUid,
            send_statue: "0",
            targetCnt: 0, // 目标数量很难计算,这里填写0
            stime: time.now().getTime(),
        };

        // 检查这条消息是否可以发送, 因为MediaManager.getVideoThumbnail耗时, 所以放在MediaManager.getVideoThumbnail前面
        const canSendThisMsg = await checkCanSend(msg)
        if (!canSendThisMsg) {
            showToast(Str_SendFail)
            return
        }

        tagCount.current = 1
        showLoading()
        // 开始群发请求
        sendMessageToSelectedTopic(msg)
    };

    const handleSubmitMedia = async (result: PickerResult[]) => {
        // 发送前重置统计
        hadDoneTags.current = new Set();
        setDoneCount(0);

        let cid = Date.now();
        const length = result.length || 0;
        if (length === 0) {
            return
        }

        // 记录任务总数
        tagCount.current = length;
        showLoading()
        // 组装发送的数据
        for (let i = 0; i < length; i++) {
            const item = result[i];
            //防止短时间内消息重复
            cid += 100 * i;

            let type: MessageType
            if (item.type === "doc") {
                type = MessageType.DOCUMENT;
            } else if (item.type === "photo" || item.mimeType.includes("octet-stream")) {
                type = MessageType.IMAGE;
            } else {
                type = MessageType.VIDEO;
            } let filePath = item.path
            let isNeedUpload = false
            if (!filePath.startsWith('http')) {
                isNeedUpload = true
                filePath = item.path.startsWith("file://") ? item.path : ("file://" + item.path);
            }

            const msg: ChartMessageItem = {
                tid: "",
                mid: "",
                cid: cid,
                type: type,
                content: isNeedUpload ? "" : filePath,
                encrypt: 0, // 当前未加密,因为要存数据库
                meta: {
                    width: item.width.toString(),
                    height: item.height.toString(),
                    mimeType: item.mimeType,
                } as any,
                sender: currentUid,
                send_statue: "0",
                targetCnt: 0, // 目标数量很难计算,这里填写0
                stime: time.now().getTime(),
                upload_path: !isNeedUpload ? "" : filePath,
                upload_statue: "0",
            };

            // 检查这条消息是否可以发送, 因为MediaManager.getVideoThumbnail耗时, 所以放在MediaManager.getVideoThumbnail前面
            const canSendThisMsg = await checkCanSend(msg)
            if (!canSendThisMsg) {
                // 记录完成
                addDoneTag(msg.cid.toString())
                continue
            }

            sendMedia(msg, isNeedUpload ? item : undefined);
        }
    };

    /// 检查某条消息 是否可以发送
    async function checkCanSend(msg: ChartMessageItem): Promise<boolean> {
        // 选择有普通用户, 可以发送
        if (setSelectUids.length) {
            return true
        }

        let canSend = false;
        for (const gTid of selectTids) {
            if (!gTid) {
                continue;
            };

            // 只要存在一个可以发送的群就返回
            const canSendToGroup = await checkMessageCanSendToGroup(msg, gTid)
            if (canSendToGroup.canSend === true) {
                canSend = true
                break
            }
        }

        return canSend;
    }

    // 检查某条消息是否可在某群发送
    async function checkMessageCanSendToGroup(msg: ChartMessageItem, gTid: string) {
        if (isGroupTopic(gTid)) {
            const { group, members } = await im.GetGroupDetail(msg.tid)
            //全体禁言
            if (group?.group_ban_chat === "1") {
                return { canSend: false, msg: `${group.name || Str_GroupName} ${Str_InProhibition}` }
            }

            // 存在发言间隔设定
            if (group?.group_chat_interval_time) {
                let lastSendTime = 0;
                // 获取当前用户在本群的最后发送时间
                const lastSendMsg = await getLastSendMsg(currentUid, gTid);
                if (lastSendMsg && lastSendMsg.length > 0) {
                    lastSendTime = lastSendMsg[0].time;
                }
                //发言间隔时间校验
                const num = Number(group.group_chat_interval_time) * 1000;
                const nowTime = time.now().getTime();
                if (lastSendTime + num > nowTime) {
                    return { canSend: false, msg: `${group.name || Str_GroupName} ${Str_SpeakFrequently}` }
                }
            }

            if (msg.type === MessageType.IMAGE && group?.group_member_image !== "1") {
                //禁止发送图片
                return { canSend: false, msg: `${group?.name || Str_GroupName} ${Str_No_images}` }
            }
            if (msg.type === MessageType.VIDEO && group?.group_member_video !== "1") {
                //禁止发送视频
                return { canSend: false, msg: `${group?.name || Str_GroupName} ${Str_No_videos}` }
            }
            if (msg.type === MessageType.DOCUMENT && group?.group_member_doc !== "1") {
                //禁止发送文件
                return { canSend: false, msg: `${group?.name || Str_GroupName} ${Str_No_documents}` }
            }
            return { canSend: true }
        }
        return { canSend: false, msg: `no group tid is not found` }
    }

    async function sendMedia(msg: ChartMessageItem, item?: PickerResult) {
        // 存到数据库
        upsetMsg(msg).then();

        // 如果不需要上传
        if (item == undefined) {
            // 开始群发请求
            sendMessageToSelectedTopic(msg)
            return
        }

        // 开始上传图片和视频
        const docSize = item.type === "doc" ? item.fileSize : undefined
        uploadProgressFile(item, currentUid, msg.cid.toString(), docSize).then(async (r) => {
            if (r.code === 0 && r.url) {
                msg.content = r.url;
                // 上传成功
                msg.send_statue = "";
                msg.upload_statue = "";
                upsetMsg(msg).then()
                // 开始群发请求
                sendMessageToSelectedTopic(msg)
            } else {
                // 上传失败
                msg.upload_statue = "1";
                msg.send_statue = "1";
                sendFail(msg, r.msg);
                // 记录完成
                addDoneTag(msg.cid.toString())
            }
        }).catch((e) => {
            // 记录完成
            addDoneTag(msg.cid.toString())
            console.log(`上传图片失败`)
        });
    }

    async function sendMessageToSelectedTopic(msg: ChartMessageItem) {
        const singleTopicIds: string[] = []
        // 群发接口 - 到个人
        for (const item of selectUids) {
            let toTopidId = await getTid(currentUid, item)
            if (toTopidId != undefined) {
                singleTopicIds.push(toTopidId)
            }
        }

        const groupTopicIds: string[] = []
        // 群发接口 - 到群聊
        for (const gTip of selectTids) {
            // 检查是否可发送带该群
            const canSendToGroup = await checkMessageCanSendToGroup(msg, gTip)
            if (canSendToGroup.canSend) {
                groupTopicIds.push(gTip)
            } else {
                showToast(canSendToGroup.msg ?? Str_SendFail)
            }
        }

        if (singleTopicIds.length === 0 && groupTopicIds.length == 0) {
            // 记录完成
            addDoneTag(msg.cid.toString())
            showToast(Str_SendFail)
            return
        }

        // 查询是否需要加密
        let encrypt = getEncrypt();

        const body: MultipleSendMsgRequestData = {
            cid: msg.cid.toString(),
            toTopicIds: [...singleTopicIds, ...groupTopicIds],
            type: msg.type,
            content: CryptEngine.encode(encrypt, msg.content, msg.cid),
            encrypt: encrypt,
            meta: msg.meta
        }

        // 发送群发请求
        try {
            const res = await multipleSendMsgs(body);
            // 记录完成
            addDoneTag(msg.cid.toString())
            console.log(`---> ${JSON.stringify(res)}`)
            if (res.code !== 0) {
                sendFail(msg, res.msg, res.code)
            } else {
                if (groupTopicIds.length) {
                    for (const gTid of groupTopicIds) {
                        await setLastSendMsg({
                            uid: msg.uid || 0,
                            tid: msg.tid,
                            time: time.now().getTime()
                        });
                    }
                }
            }
        } catch (res: any) {
            // 记录完成
            addDoneTag(msg.cid.toString())
            sendFail(msg, (res?.msg || Str_SendFail), res?.code)
        }

    }

    // 获取单聊的tid
    async function getTid(senderUid: number, reciverUid: number) {
        const tid = buildSingleTopicId(senderUid, reciverUid);
        const r = await im.GetTopicDetail(tid, true);
        // 会话已存在
        if (r.topic) {
            log.info('会话已存在，直接唤出', r.topic.topic.tid);
            return r.topic.topic.tid
        }

        // 会话不存在 - 创建会话
        const members = [reciverUid];
        if (reciverUid !== currentUid) {
            members.push(currentUid);
        }

        const r1 = await im.CreateTopic({
            name: '',
            type: 'single',
            members: members,
        });

        if (r1.topic) {
            return r1.topic.tid
        }

        // 创建会话失败
        showToast(Str_CreatTopicErr)
        return undefined;
    }

    function sendFail(failMsg: ChartMessageItem, errMsg?: string, code?: number) {
        // 上传失败
        failMsg.upload_statue = "1";
        failMsg.send_statue = "1";
        upsetMsg(failMsg).then()
        // ??
        if (code === 1007) {
            return
        }
        showToast(errMsg || Str_SendFail)
    }

    function onInputTypeChanged(type: ActiveIcon) {
        const isHadSelected = (selectUids.size > 0 || selectTids.size > 0)
        setBottomSafeAreaShow(isHadSelected && (type == 'emoji' ? false : true))
    }

    return (
        <BaseScreen styles={{ backgroundColor: ColorF5F5F5 }}>
            <NavBar
                title={Str_MassSendingAssistant}
                showBack={Platform.OS !== 'web'}
                rightClick={selectAll}
                rightChildren={
                    <Text style={{ fontSize: 14, color: color_main }}>{isSelectAll ? Str_UnSelectAll : Str_SelectAll}</Text>
                }
            />
            <View
                style={{
                    backgroundColor: isBottomSafeAreaShow ? "white" : ColorF5F5F5,
                    width: "100%",
                    height: insets.bottom,
                    bottom: 0,
                    position: "absolute",
                }}
            />
            <SectionList
                style={{ flex: 1 }}
                sections={section}
                renderSectionHeader={SectionHeader}
                keyExtractor={(item, index) => index.toString()}
                renderItem={RenderItem}
            />
            {(selectUids.size > 0 || selectTids.size > 0) &&
                <KeyboardAvoidingView behavior={"height"} style={{ overflow: "visible", paddingBottom: insets.bottom }}>
                    <ChatInput
                        topicId={""}
                        from='MassSending'
                        isHadQuote={false}
                        canSpeak={true}
                        onInputTypeChanged={onInputTypeChanged}
                        onSubmit={handleSubmitMsg} // 文字/语音或/表情/自定义表情消息,单条
                        onSubmitMedia={handleSubmitMedia} // 发送图片和视频消息, 可能多条
                        type={ChatType.SINGLE}
                        showImage={true}
                        showVideo={true}
                        showFile={true}
                        showCall={true}
                        onCallAudio={() => { }}
                        onCallVideo={() => { }}
                    />
                </KeyboardAvoidingView>
            }
        </BaseScreen>)
}

const styles = StyleSheet.create({
    item: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 16,
        height: 55,
    },
    header: {
        fontSize: 16,
        marginStart: 16,
        color: "#737373"
    },
    itemText: {
        fontSize: 17,
        marginStart: 12,
        color: color_1E1E1E
    },
    itemLine: {
        position: "absolute",
        bottom: 0,
        start: 70,
        height: 1,
        end: 0,
        backgroundColor: color_F1F1F1
    },
    modalWrap: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
    },
    modalView: {
        backgroundColor: 'white',
        borderRadius: 4,
        width: '85%',
        paddingTop: 20,
        minHeight: 200,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    modalTitle: {
        fontSize: 16,
        color: color_333333,
        fontFamily: '',
        fontWeight: '600',
    },

    input: {
        borderColor: ColorGrey,
        backgroundColor: ColorGrey,
        borderRadius: 4,
        minHeight: 40,
        marginHorizontal: 20,
        paddingLeft: 15,
    },
    btnContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginHorizontal: 20,
    },
    btnStyle: {
        flex: 1,
        alignItems: 'center',
        paddingBottom: 20,
        paddingTop: 10
    },
    btn: {
        color: color_999999,
        fontSize: 16,
        fontWeight: 'bold',
        fontFamily: ''
    }
})